import { useTranslate } from '@bynder/localization';
import { englishText } from '../../../../connectors/Localization/englishText';
import { SelectedSearchOption } from '../../helpers/types';
import { SearchResults } from '../../types';
import { ResultsCategory } from '../constants';

export type CategoryDisabledReason = 'noMatch' | 'notSearchable';

export type TranslationKey = keyof typeof englishText;
type Translate = ReturnType<typeof useTranslate>['translate'];

type CategoryChipLabelArgs = {
	translate: Translate;
	idleKey: TranslationKey;
	countKey: TranslationKey;
	totalResults: number;
	hasNoCountsToShow: boolean;
	isLoadingResults: boolean;
};

export function getCategoryChipLabel({
	translate,
	idleKey,
	countKey,
	totalResults,
	hasNoCountsToShow,
	isLoadingResults,
}: CategoryChipLabelArgs) {
	if (hasNoCountsToShow || isLoadingResults) {
		return translate(idleKey);
	}

	return translate(countKey, { count: totalResults });
}

export function hasResultsForCategory(category: ResultsCategory, searchResults: SearchResults) {
	switch (category) {
		case ResultsCategory.Assets:
			return (
				searchResults.assets.total > 0 ||
				searchResults.tags.length > 0 ||
				searchResults.metaproperties.length > 0
			);
		case ResultsCategory.Collections:
			return searchResults.collections.total > 0;
		case ResultsCategory.Guidelines:
			return searchResults.guidelines.items.length > 0;
		default:
			return true;
	}
}

type CategoryDisabledReasonArgs = {
	searchResults: SearchResults;
	selectedSearchOptions: SelectedSearchOption[];
};

export function getCategoryDisabledReason(
	category: ResultsCategory,
	{ searchResults, selectedSearchOptions }: CategoryDisabledReasonArgs,
): CategoryDisabledReason | null {
	if (category !== ResultsCategory.Assets && selectedSearchOptions.length > 0) {
		return 'notSearchable';
	}

	return hasResultsForCategory(category, searchResults) ? null : 'noMatch';
}
